class ErrorPage {
  constructor() {
    let $imageElem = $('.js-error-page__image');
    let $imageElemAlt = $('.js-error-page__image--hidden');

    if ($imageElem.length > 0 && $imageElemAlt.length > 0) {
      $imageElem.on('dblclick', (event) => {
        event.preventDefault();
        event.stopPropagation();
        $imageElem.attr('src', $imageElemAlt.attr('src'));
      });
    }

    let $searchField = $('.js-search-input ');

    if ($searchField.length > 0 && $imageElem.length > 0) {
      $searchField.on('keyup', () => {
        if ($searchField.val() === 'tute tute tute tute!') {
          $imageElem.attr('src', 'https://i.giphy.com/XGUU3XecDpEl1iLg4C.gif');
        }
      });
    }
  }
}

export function init() {
  new ErrorPage();
}
